import Caduceo from "../";

const routes = [
    { name: "PrescrizioniRipetibili", path: "/prescrizioniripetibili", component: Caduceo.PrescrizioniRipetibili, meta: { title: "" } },
    { name: "PrenotazioniAgenda", path: "/prenotazioniagenda", component: Caduceo.PrenotazioniAgenda, meta: { title: "" } },
    { name: "PrenotazioniAgenda", path: "/prenotazioniagenda/appuntamenti/:id", component: Caduceo.PrenotazioniAgendaAppuntamenti, meta: { title: "" } },
];

export default routes;
